module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "dropdown relation-dropdown",
    style: (_vm.select ? 'text-align: left;' : ''),
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.openDropdown($event)
      }
    }
  }, [_c('div', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [(!_vm.select) ? _c('img', {
    staticClass: "img-add",
    attrs: {
      "src": require("../../assets/images/faces/ic_add_24px.svg")
    }
  }) : _vm._e(), _c('span', {
    style: (_vm.select ? 'margin-left: 0; color:#4B2D15; font-size:12px;' : '')
  }, [_vm._v(_vm._s(_vm.selectedValue))]), (_vm.select) ? _c('div', {
    staticClass: "material-icons"
  }, [_vm._v("signal_cellular_4_bar")]) : _vm._e(), _c('ul', {
    staticClass: "dropdown-menu relation-dropdown-menu"
  }, _vm._l((_vm.relations), function(r) {
    return _c('li', {
      staticClass: "li-relation-add"
    }, [_c('a', {
      staticClass: "dropdown-item relation-dropdown-item",
      attrs: {
        "href": ""
      },
      on: {
        "click": function($event) {
          return _vm.changeValue(r.code)
        }
      }
    }, [_vm._v(_vm._s(r.name))])])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d3bdd34","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Relation/dropdown.vue
// module id = 1576
// module chunks = 0